import axiosInstance from '../axiosConfig';

export default {
  async getAddresInfoByZipCode(payload) {
    const response = await axiosInstance.post(
      'EcomDespliegueDireccion',
      payload
    );
    return response.data;
  },
  async getUserAddressInfo(payload) {
    const response = await axiosInstance.post('EcomSelDireccionEnvio', payload);
    return response.data;
  },
};
